export const initialState = {
  getData: {
    loading: false,
    success: false,
    error: false,
    data: {},
  },
};
